/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface NotificationConfig
 */
export interface NotificationConfig {
  /**
   * A list of additional headers to be added to the notification request when using http or https. This is intended to support authentication or authorization, for example by supplying an OAuth2 bearer token.
   * @type {Array<string>}
   * @memberof NotificationConfig
   */
  auth_headers?: Array<string>;
  /**
   * Specifies a list of items to be attached to the notification message. When multiple items are requested, they are included as named file attachments.
   * @type {Array<string>}
   * @memberof NotificationConfig
   */
  contents?: Array<NotificationConfigContentsEnum>;
  /**
   * The method to be used with http and https urls. The default is post.
   * @type {string}
   * @memberof NotificationConfig
   */
  method?: NotificationConfigMethodEnum;
  /**
   * The url to which a notification message will be sent upon completion of the job. The job `id` and `status` are added as query parameters, and any combination of the job inputs and outputs can be included by listing them in `contents`.  If `contents` is empty, the body of the request will be empty.  If only one item is listed, it will be sent as the body of the request with `Content-Type` set to an appropriate value such as `application/octet-stream` or `application/json`.  If multiple items are listed they will be sent as named file attachments using the multipart content type.  If `contents` is not specified, the `transcript` item will be sent as a file attachment named `data_file`, for backwards compatibility.  If the job was rejected or failed during processing, that will be indicated by the status, and any output items that are not available as a result will be omitted. The body formatting rules will still be followed as if all items were available.  The user-agent header is set to `Speechmatics-API/2.0`, or `Speechmatics API V2` in older API versions.
   * @type {string}
   * @memberof NotificationConfig
   */
  url: string;
}

export const NotificationConfigContentsEnum = {
  Jobinfo: 'jobinfo',
  Transcript: 'transcript',
  TranscriptJsonV2: 'transcript.json-v2',
  TranscriptTxt: 'transcript.txt',
  TranscriptSrt: 'transcript.srt',
  Alignment: 'alignment',
  AlignmentWordStartAndEnd: 'alignment.word_start_and_end',
  AlignmentOnePerLine: 'alignment.one_per_line',
  Data: 'data',
  Text: 'text',
  Lattice: 'lattice',
} as const;

export type NotificationConfigContentsEnum =
  typeof NotificationConfigContentsEnum[keyof typeof NotificationConfigContentsEnum];
export const NotificationConfigMethodEnum = {
  Post: 'post',
  Put: 'put',
} as const;

export type NotificationConfigMethodEnum =
  typeof NotificationConfigMethodEnum[keyof typeof NotificationConfigMethodEnum];
